<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

      <p>Натискання цієї кнопки дозволяє примусово виконати синхронізацію даних менеджерів та компаній, за якими вони закріплені, з CRM. Також у процесі синхронізації буде встановлено зв’язки між менеджерами та клієнтами якщо вони передбачені у CRM, але були відсутні у чат-боті до синхронізації. Синхронізація виконується автоматично за графіком кожну годину о 00 хвилин.</p>
    <div class="buttons">
      <b-button variant="outline-success" @click="sync">
        Синхронізувати
      </b-button>
    </div>

    <b-table striped hover :items="items" :fields="fields" v-if="reload">
      <template v-slot:cell(Телефон)="data">
        <b-form-input v-model="items[data.index].phone"
                      :state="valid(data.index)"
                      @change="(ev) => edit(ev, data)"></b-form-input>
      </template>
      <template v-slot:cell(Дії)="data">
        <b-button variant="success"
                  :disabled="items[data.index].phone === original[data.index].phone || !valid(data.index)"
                  @click="() => save(data)">Зберегти
        </b-button>
        <b-button variant="danger" @click="() => remove(data)">Видалити</b-button>
      </template>
    </b-table>
  </div>
</template>

<script lang="js">
import LoadSpinner from '../components/LoadSpinner';
import {deleteManager, getManagers, syncManagers, updateManager} from "@/services/Managers.service";

export default {
  name: 'src-components-managers',
  components: {LoadSpinner},
  props: [],
  mounted() {
    this.showSpinner = true;
    getManagers()
        .then((managers) => {
          this.items = managers.map(manager => {
            return {
              id: manager['id'],
              'Ім\'я': manager['name'],
              name: manager['name'],
              'Телефон': manager['phone'],
              phone: manager['phone'],
            }
          }).sort((a, b) => a - b);
          this.original = JSON.parse(JSON.stringify(this.items))
          this.showSpinner = false;
          this.reqSuccess = true;
        })
        .catch(err => {
          this.showSpinner = false;
          this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
          this.reqSuccess = false;
          this.showModal();
        });
  },
  data() {
    return {
      fields: ['Ім\'я', 'Телефон', 'Дії'],
      items: [],
      original: [],
      showSpinner: false,
      reload: true,
      reqSuccess: true,
      reqResult: '',
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(() => {
        this.$refs['req-result'].hide();
      }, 2000);
    },
    save(data) {
      this.showSpinner = true;
      updateManager(this.items[data.index].id, this.items[data.index].phone)
          .then(() => {
            this.showSpinner = false;
            this.reqResult = 'Дані змінені';
            this.reqSuccess = true;
            this.showModal();
          })
          .catch((err) => {
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    remove(data) {
      this.showSpinner = true;
      deleteManager(this.items[data.index].id)
          .then(() => {
            this.items.splice(data.index, 1);
            this.reload = false;
            this.showSpinner = false;
            this.reload = true;
            this.reqResult = 'Дані змінені';
            this.reqSuccess = true;
            this.showModal();
          })
          .catch((err) => {
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
    edit(e, item) {
      this.items[item.index].phone = e;
      this.items[item.index]['Телефон'] = e;
    },
    valid(index) {
      let result;
      if (this.items[index].phone) {
        const regex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        result = regex.test(this.items[index].phone);
      } else {
        result = null
      }
      return result;
    },
    sync() {
      this.showSpinner = true;
      syncManagers()
          .then(() => {
            return getManagers()
          })
          .then((managers) => {
            this.items = managers.map(manager => {
              return {
                id: manager['id'],
                'Ім\'я': manager['name'],
                name: manager['name'],
                'Телефон': manager['phone'],
                phone: manager['phone'],
              }
            }).sort((a, b) => a - b);
            this.reload = false;
            this.original = JSON.parse(JSON.stringify(this.items))
            this.showSpinner = false;
            this.reload = true;
            this.reqSuccess = true;
          })
          .catch((err) => {
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          })
    },
  },
  computed: {}
}
</script>

<style lang="scss">
.wrapper {
  padding: 16px 32px;
  display: flex;
  flex-direction: column;

  .buttons {
    margin-bottom: 48px;
  }

  .table {
    margin-bottom: 128px;

    td[aria-colindex="3"] {
      display: inline-flex;
      justify-content: center;

      button {
        margin: 8px;
      }
    }
  }
}

.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}
</style>
